import { ConfirmDialog, useToast } from '@orbind/ui'
import { useEffect, useRef, useState } from 'react'
import { usePresence } from './PresenceProvider.tsx'

/**
 * O que acontece quando a pessoa ABRE o Orbind com um status antigo pendurado
 * (SPEC-20260924-0924, pedido do usuário).
 *
 * São dois casos, e a diferença entre eles é de intenção:
 *
 * - **Ausente** é um recado temporário ("saí para almoçar"). Voltar e ainda
 *   aparecer ausente engana os colegas, então o Orbind volta sozinho para
 *   disponível e só avisa que fez isso.
 * - **Offline** é uma decisão deliberada de não aparecer — fim de expediente,
 *   folga, trabalho concentrado. Desfazer isso sem perguntar seria expor a
 *   pessoa justamente quando ela pediu para não ser vista. Aqui o Orbind
 *   PERGUNTA, e o padrão é continuar como está.
 */
export function VoltarAoTrabalho() {
  const { meuEstado, escolherStatus } = usePresence()
  const toast = useToast()
  const [perguntando, setPerguntando] = useState(false)
  /*
   * Uma vez por abertura do app. Sem isto, escolher "não" e ficar offline
   * faria a pergunta voltar a cada reconexão do canal — o Orbind insistindo
   * para a pessoa aparecer, que é exatamente o contrário do que ela pediu.
   */
  const jaTratou = useRef(false)

  useEffect(() => {
    if (jaTratou.current) return
    // 'desconectado' é o estado antes da abertura do canal: ainda não sei nada
    if (meuEstado === 'desconectado') return

    if (meuEstado === 'ausente') {
      jaTratou.current = true
      escolherStatus('disponivel')
      toast.push({ tone: 'success', message: 'Você entrou online' })
      return
    }
    if (meuEstado === 'offline') {
      jaTratou.current = true
      setPerguntando(true)
    }
  }, [meuEstado, escolherStatus, toast])

  return (
    <ConfirmDialog
      open={perguntando}
      title="Voltar a aparecer online?"
      description="Você está como offline para os colegas. Quer voltar a aparecer disponível?"
      confirmLabel="Ficar online"
      cancelLabel="Continuar offline"
      onConfirm={() => {
        setPerguntando(false)
        escolherStatus('disponivel')
        toast.push({ tone: 'success', message: 'Você entrou online' })
      }}
      onCancel={() => setPerguntando(false)}
    />
  )
}
